(function () {
  var STRIP_RE = /\s*\(\s*\d[\d,]*\s*\)\s*/g;

  function stripCount(el) {
    if (!el || el.dataset.wnCountStripped === 'true') return;
    var stripped = el.textContent.replace(STRIP_RE, '').trim();
    if (stripped === el.textContent.trim()) return;
    if (stripped === '') {
      el.style.display = 'none';
    } else {
      el.textContent = stripped;
    }
    el.dataset.wnCountStripped = 'true';
  }

  function sweep(root) {
    (root || document).querySelectorAll('.jdgm-rating-text').forEach(stripCount);
  }

  sweep();

  var obs = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.classList && node.classList.contains('jdgm-rating-text')) stripCount(node);
        if (node.querySelectorAll) sweep(node);
      }
    }
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
